import { useLogout } from 'react-admin'
import useHistoryPush from './useHistoryPush'
import { useSignalRConnectionContext } from '../context/useSignalRConnectionContext'

// Logs out after closing the SignalR connection, and drops the org/team params from the url.
const useEndSession = () => {
  const { redirect } = useHistoryPush()
  const logout = useLogout()
  const { connection } = useSignalRConnectionContext()

  return () => {
    const end = () => {
      redirect('/', [], ['org', 'team'])
      logout()
    }
    if (connection) connection.stop().then(end)
    else end()
  }
}

export default useEndSession
